import React from 'react'
import type { Timeline, Marker, Timespan, Photo } from '@app-types/entity_types'
import { ProvidedHorizontalTimelineCore } from '@features/horizontal_timeline_core/components/HorizontalTimelineCore'
import { passThroughDerive } from '@features/horizontal_timeline_core/derivation/strategies'
import { ViewProvider } from '@base/ViewContext'
import MarkerContent from './MarkerContent'
import TimespanContent from './TimespanContent'
import type { ViewContextValue } from '../types'

export interface HorizontalTimelineProps {
  timeline: Timeline
  markers: Marker[]
  timespans: Timespan[]
  photos: Record<number, Photo>
}

// Classic (legacy-shape) horizontal timeline wrapper powered by the new core.
// Derives internal marker/timespan models via passThroughDerive.
const HorizontalTimeline: React.FC<HorizontalTimelineProps> = ({ timeline: _timeline, markers, timespans, photos }) => {
  const viewContextValue: ViewContextValue = {
    componentMap: {
      MarkerContent,
      TimespanContent,
    },
  }
  return (
    <ViewProvider value={viewContextValue}>
      <ProvidedHorizontalTimelineCore
        derivationContext={{ rawData: { markers, timespans } }}
        deriveTimelineItems={passThroughDerive}
        photos={photos}
      />
    </ViewProvider>
  )
}

export default HorizontalTimeline
